module.exports = __webpack_public_path__ + "img/red-minus.e106d76b.svg";